module.exports = __webpack_public_path__ + "files/5e1a30f477c6066b224c4972fbbe0cc2.png";